/***
 * @file:
 * @author: linkun.he
 * @Date: 2020-12-18 16:30:31
 */
let handler;

function _registerEvent(target, eventType, cb) {
  if (target.addEventListener) {
    target.addEventListener(eventType, cb);
    return {
      remove() {
        target.removeEventListener(eventType, () => {
          console.log('blur--->');
          cb();
        });
      },
    };
  } else {
    target.attachEvent(eventType, cb);
    return {
      remove() {
        target.detachEvent(eventType, cb);
      },
    };
  }
}

function _createHiddenIframe(target, uri) {
  const iframe = document.createElement('iframe');
  iframe.src = uri;
  iframe.id = 'hiddenIframe';
  iframe.style.display = 'none';
  target.appendChild(iframe);

  return iframe;
}

function openUriWithHiddenFrame(uri, failCb, successCb) {
  const timeout = setTimeout(() => {
    failCb();
    handler.remove();
  }, 1000);

  let iframe: any = document.querySelector('#hiddenIframe');
  if (!iframe) {
    iframe = _createHiddenIframe(document.body, 'about:blank');
  }
  handler = _registerEvent(window, 'blur', onBlur);
  function onBlur() {
    clearTimeout(timeout);
    handler.remove();
    successCb();
  }

  iframe.contentWindow.location.href = uri;
}

function openUriWithTimeoutHack(uri, failCb, successCb) {
  const timeout = setTimeout(() => {
    failCb();
    handler.remove();
  }, 5000);

  // handle page running in an iframe (blur must be registered with top level window)
  let target: any = window;
  while (target !== target.parent) {
    target = target.parent;
  }
  target.focus();
  const ipt = document.querySelector('input');
  ipt.focus();
  console.log('ipt', ipt);
  handler = _registerEvent(ipt, 'blur', onBlur);
  function onBlur() {
    clearTimeout(timeout);
    handler.remove();
    successCb();
  }

  window.location = uri;
}

function openUriUsingFirefox(uri, failCb, successCb) {
  let iframe: any = document.querySelector('#hiddenIframe');

  if (!iframe) {
    iframe = _createHiddenIframe(document.body, 'about:blank');
  }

  try {
    iframe.contentWindow.location.href = uri;
    successCb();
  } catch (e) {
    if (e.name === 'NS_ERROR_UNKNOWN_PROTOCOL') {
      failCb();
    }
  }
}

function openUriUsingIEInOlderWindows(uri, failCb, successCb) {
  if (getInternetExplorerVersion() === 10) {
    openUriUsingIE10InWindows7(uri, failCb, successCb);
  } else if (getInternetExplorerVersion() === 9 || getInternetExplorerVersion() === 11) {
    openUriWithHiddenFrame(uri, failCb, successCb);
  } else {
    openUriInNewWindowHack(uri, failCb, successCb);
  }
}

function openUriUsingIE10InWindows7(uri, failCb, successCb) {
  const timeout = setTimeout(failCb, 1000);
  window.addEventListener('blur', () => {
    clearTimeout(timeout);
    successCb();
  });

  let iframe: any = document.querySelector('#hiddenIframe');
  if (!iframe) {
    iframe = _createHiddenIframe(document.body, 'about:blank');
  }
  try {
    iframe.contentWindow.location.href = uri;
  } catch (e) {
    failCb();
    clearTimeout(timeout);
  }
}

function openUriInNewWindowHack(uri, failCb, successCb) {
  const myWindow = window.open('', '', 'width=0,height=0');

  myWindow.document.write("<iframe src='" + uri + "'></iframe>");

  setTimeout(() => {
    try {
      // tslint:disable-next-line:no-unused-expression
      myWindow.location.href;
      myWindow.setTimeout('window.close()', 1000);
      successCb();
    } catch (e) {
      myWindow.close();
      failCb();
    }
  }, 1000);
}

function openUriWithMsLaunchUri(uri, failCb, successCb) {
  navigator.msLaunchUri(uri, successCb, failCb);
}

function checkBrowser() {
  const isOpera = !!(window as any).opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  const ua = navigator.userAgent.toLowerCase();
  return {
    isOpera,
    isFirefox: typeof (window as any).InstallTrigger !== 'undefined',
    isSafari:
      // tslint:disable-next-line:no-bitwise
      (~ua.indexOf('safari') && !~ua.indexOf('chrome')) ||
      Object.prototype.toString.call((window as any).HTMLElement).indexOf('Constructor') > 0,
    isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream,
    isChrome: !!(window as any).chrome && !isOpera,
    isIE: /*@cc_on!@*/ false || !!(document as any).documentMode, // At least IE6
  };
}

function getInternetExplorerVersion() {
  let rv = -1;
  if (navigator.appName === 'Microsoft Internet Explorer') {
    const ua = navigator.userAgent;
    const re = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');
    if (re.exec(ua) != null) {
      rv = parseFloat(RegExp.$1);
    }
  } else if (navigator.appName === 'Netscape') {
    const ua = navigator.userAgent;
    const re = new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})');
    if (re.exec(ua) != null) {
      rv = parseFloat(RegExp.$1);
    }
  }
  return rv;
}

export const protocolCheck = (uri, failCb = () => {}, successCb = () => {}, unsupportedCb = () => {}) => {
  function failCallback() {
    if (failCb) {
      failCb();
    }
  }

  function successCallback() {
    if (successCb) {
      successCb();
    }
  }

  if (navigator.msLaunchUri) {
    // for IE and Edge in Win 8 and Win 10
    openUriWithMsLaunchUri(uri, failCb, successCb);
  } else {
    const browser = checkBrowser();

    if (browser.isFirefox) {
      openUriUsingFirefox(uri, failCallback, successCallback);
    } else if (browser.isChrome || browser.isIOS) {
      openUriWithTimeoutHack(uri, failCallback, successCallback);
    } else if (browser.isIE) {
      openUriUsingIEInOlderWindows(uri, failCallback, successCallback);
    } else if (browser.isSafari) {
      openUriWithHiddenFrame(uri, failCallback, successCallback);
    } else {
      unsupportedCb();
      // not supported, implement please
    }
  }
};
